import { API } from "@thenounproject/lingo-core";
import { showNotification } from "@actions/useNotifications";
import { createAsyncAction } from "../actionCreators";

export type ArgTypes = {
  assetId: string;
  data: File;
};

const [useUpdateAssetThumbnail, updateAssetThumbnail] = createAsyncAction(
  "assets/selectThumbnail",
  async (arg: ArgTypes, thunkApi) => {
    const { assetId, data } = arg;
    const type = data.type.split("/")[1].toUpperCase();
    const formData = new FormData();
    formData.append("asset", data);
    formData.append("json", JSON.stringify({ type }));
    try {
      const res = await API.call<{ asset: string }>({
        endpoint: `assets/${assetId}/preview`,
        method: "PUT",
        formData,
      });
      return { ...res, result: res.result.asset };
    } catch (err) {
      thunkApi.dispatch(
        showNotification({ message: "Failed to upload custom thumbnail", level: "error" })
      );
      throw err;
    }
  }
);

export default useUpdateAssetThumbnail;
export { updateAssetThumbnail };
